import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, ElementRef, inject, Renderer2 } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, NavigationError, Router, RouterOutlet } from '@angular/router';
import { App } from '@df/core/app';
import { Client } from '@df/core/service/client';
@Component({
    selector: 'app',
    styles: [
        `
            :host {
                height: inherit;
            }
        `
    ],
    template: `<router-outlet />`,
    imports: [RouterOutlet],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
    private readonly client = inject(Client);
    private readonly elementRef = inject(ElementRef<HTMLElement>);
    private readonly changeDetectorRef = inject(ChangeDetectorRef);
    private readonly router = inject(Router);
    private readonly renderer2 = inject(Renderer2);
    private readonly document = inject(DOCUMENT);
    private readonly destroyRef = inject(DestroyRef);
    private readonly app = inject(App);

    constructor() {
        this.app.hasSSRCode =
            (this.elementRef.nativeElement as HTMLElement).hasAttribute('ng-server-context') || this.app.client.mode === 'ssr';

        this.client.isCms$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(isCms => {
            if (isCms) {
                this.setAsRoot(this.elementRef.nativeElement);
            } else {
                this.setAsRoot((this.document.scrollingElement || this.document.body) as HTMLElement);
            }
        });
    }

    ngOnInit() {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd || event instanceof NavigationError) {
                this.detectChanges();
            }
        });
    }

    private setAsRoot(element: HTMLElement) {
        const currentRoot = this.client.getRootElement();
        if (currentRoot !== element) {
            if (currentRoot) {
                this.renderer2.removeClass(currentRoot, 'app-root');
            }
            // app-root class is set in global.scss
            this.renderer2.addClass(element, 'app-root');
            this.client.setRootElement(element);
        }
    }
    private detectChanges() {
        this.changeDetectorRef.detectChanges();
    }
}
